import type { Benefit, FaqItem, PackItem, PainPoint } from '../types/content'

export const CTA_LABEL = '🛡️ QUIERO MI ESCUDO DIGITAL — ACCESO INMEDIATO'

export const CHECKOUT_URL = 'https://escudo-digital-2026.impultienda.ar/checkout'

export const PRICE = '$15.990'
export const PRICE_CURRENCY = 'ARS'
export const TOTAL_VALUE = '$25.000 ARS'

export const painPoints: PainPoint[] = [
  {
    title: 'Un link que tocaste sin querer',
    description: 'Llega disfrazado de promo, de encuesta o de un mensaje de tu banco. Un toque alcanza.',
  },
  {
    title: 'Un código que pasaste por teléfono',
    description: 'Te llaman "de soporte", te apuran, te generan miedo. Y vos leés los 6 dígitos en voz alta.',
  },
  {
    title: 'Una red Wi-Fi pública',
    description: 'La del bar, la del aeropuerto, la del shopping. Gratis para vos, gratis para ellos.',
  },
]

export const benefits: Benefit[] = [
  {
    title: 'WhatsApp Blindado',
    description:
      'Activá el escudo que impide que cualquier otra persona abra tu cuenta, incluso si clonan tu chip.',
  },
  {
    title: 'Billeteras Seguras',
    description:
      'Configurá Mercado Pago y tus bancos para que cada peso esté bajo triple candado.',
  },
  {
    title: 'Privacidad Total',
    description:
      'Aprendé a navegar sin dejar rastro y a detectar estafas antes de que lleguen a tu bandeja de entrada.',
  },
  {
    title: 'Tranquilidad Familiar',
    description:
      'Aplicá estos mismos pasos en los teléfonos de tus hijos y padres mayores: el blanco favorito de los estafadores.',
  },
]

export const packItems: PackItem[] = [
  {
    icon: 'guide',
    title: 'Guía Maestra Escudo Digital',
    description: 'El plan de acción completo, paso a paso, para blindar tu celular hoy mismo.',
    value: '$12.000',
  },
  {
    icon: 'bonus',
    title: 'BONO 1 · Checklist "Acción Inmediata"',
    description: 'Qué hacer, minuto a minuto, si te roban el celular hoy.',
    value: '$5.000',
  },
  {
    icon: 'bonus',
    title: 'BONO 2 · Manual Anti-Phishing',
    description: 'Cómo detectar links falsos en 3 segundos, sin ser experto.',
    value: '$4.500',
  },
  {
    icon: 'bonus',
    title: 'BONO 3 · Contraseñas Inviolables',
    description: 'Guía de contraseñas imposibles de adivinar y gestores seguros.',
    value: '$3.500',
  },
]

export const faqItems: FaqItem[] = [
  {
    question: '¿Es difícil de aplicar?',
    answer:
      'No. Está escrito para que lo entienda desde un adolescente hasta una persona mayor. Son pasos de "tocar este botón" y "activar esta opción".',
  },
  {
    question: '¿Qué pasa si ya me hackearon?',
    answer:
      'Dentro de la guía tenemos una sección de "Primeros Auxilios Digitales" para ayudarte a intentar recuperar el control.',
  },
  {
    question: '¿Funciona para iPhone y Android?',
    answer:
      'Sí, el método cubre ambos sistemas operativos y las apps más usadas en Argentina (WhatsApp, Mercado Pago, Homebanking).',
  },
]
